export default {
  divisionsReceived: 'divisionsReceived',
}



// WEBPACK FOOTER //
// ./modules/actions/divisions.actions.js